(function () {
  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function renderDetail(panel, farmer, buttonLabel) {
    const imageMarkup = farmer.image
      ? `<img src="${escapeHtml(farmer.image)}" alt="${escapeHtml(farmer.imageAlt || farmer.name)}" class="farmer-map-section__image" loading="lazy">`
      : `<div class="farmer-map-section__image-placeholder">${escapeHtml(farmer.name)}</div>`;

    const linkMarkup = farmer.showProfileButton
      ? farmer.link
        ? `<a href="${escapeHtml(farmer.link)}" class="farmer-map-section__button">${escapeHtml(buttonLabel)}</a>`
        : `<span class="farmer-map-section__button farmer-map-section__button--disabled" aria-disabled="true">${escapeHtml(buttonLabel)}</span>`
      : '';

    panel.innerHTML = `
      ${imageMarkup}
      <h3 class="farmer-map-section__farmer-name">${escapeHtml(farmer.name)}</h3>
      <p class="farmer-map-section__family">${escapeHtml(farmer.family)}</p>
      <p class="farmer-map-section__desc">${escapeHtml(farmer.desc)}</p>
      ${linkMarkup}
    `;
  }

  function loadLeaflet(callback) {
    if (window.L) {
      callback();
      return;
    }

    const existing = document.querySelector('script[data-farmer-map-leaflet]');
    if (existing) {
      existing.addEventListener('load', callback, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    script.defer = true;
    script.dataset.farmerMapLeaflet = 'true';
    script.addEventListener('load', callback, { once: true });
    document.head.appendChild(script);
  }

  function initSection(section) {
    if (section.dataset.farmerMapInitialized === 'true') return;

    const mapElement = section.querySelector('[data-farmer-map]');
    const detailPanel = section.querySelector('[data-farmer-detail]');
    const dataElement = section.querySelector('[data-farmer-map-data]');

    if (!mapElement || !detailPanel || !dataElement || !window.L) return;

    let config;
    try {
      config = JSON.parse(dataElement.textContent || '{}');
    } catch (error) {
      return;
    }

    const farmers = (config.farmers || [])
      .map((farmer) => ({
        ...farmer,
        lat: parseFloat(String(farmer.lat).replace(',', '.')),
        lng: parseFloat(String(farmer.lng).replace(',', '.')),
      }))
      .filter((farmer) => Number.isFinite(farmer.lat) && Number.isFinite(farmer.lng));
    if (!farmers.length) return;

    section.dataset.farmerMapInitialized = 'true';

    const centerLat = parseFloat(String(config.centerLat).replace(',', '.'));
    const centerLng = parseFloat(String(config.centerLng).replace(',', '.'));

    const center = [
      Number.isFinite(centerLat) ? centerLat : farmers[0].lat,
      Number.isFinite(centerLng) ? centerLng : farmers[0].lng,
    ];

    const map = L.map(mapElement, {
      scrollWheelZoom: Boolean(config.scrollWheelZoom),
    }).setView(center, config.zoom || 13);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap',
    }).addTo(map);

    const bounds = [];
    farmers.forEach((farmer) => {
      const marker = L.marker([farmer.lat, farmer.lng]).addTo(map);
      marker.bindTooltip(farmer.name || '', { direction: 'top' });
      marker.on('click', () => renderDetail(detailPanel, farmer, config.buttonLabel || 'Zum Profil'));
      bounds.push([farmer.lat, farmer.lng]);
    });

    if (config.fitMarkers && bounds.length > 1) {
      map.fitBounds(bounds, { padding: [32, 32], maxZoom: config.zoom || 13 });
    }

    if (config.showFirstFarmer) {
      renderDetail(detailPanel, farmers[0], config.buttonLabel || 'Zum Profil');
    }

    window.setTimeout(() => map.invalidateSize(), 250);
  }

  function initAll() {
    loadLeaflet(() => {
      document.querySelectorAll('[data-farmer-map-section]').forEach(initSection);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-farmer-map-section]');
    if (!section) return;
    loadLeaflet(() => initSection(section));
  });
})();
